import { defineRouting } from "next-intl/routing";

// Supported languages. `hy` = Armenian, `ru` = Russian, `en` = English.
export const locales = ["hy", "ru", "en"] as const;
export type Locale = (typeof locales)[number];

export const routing = defineRouting({
  locales,
  defaultLocale: "en",
  // Always show the locale in the URL (e.g. /en, /hy, /ru) for clarity & SEO.
  localePrefix: "always",
});
